/*
 * Baby Savage: Add to cart siempre por el carrito lateral, nunca por la pagina /cart.
 *
 * El tema trae su propio "ajax-cart.js" con un ajaxCart.init() que intercepta
 * los formularios de compra, pero ese init() nunca se llama en ningun lado del
 * tema (main-product-template.liquid lo hace, pero nuestras secciones custom no
 * usan esa plantilla). Sin eso, el <form action="/cart/add"> hace un submit
 * nativo y el navegador va de lleno a la pagina del carrito.
 *
 * Aqui se intercepta a nivel de documento CUALQUIER formulario que apunte a
 * /cart/add (el buybox visible, el formulario legado que dispara la barra
 * movil, y el "agregar rapido" de las tarjetas de producto), se manda por
 * fetch a /cart/add.js y se abre el drawer del propio tema (#CartDrawer) en
 * vez de dejar navegar la pagina.
 *
 * Ademas se publica window.BabySavageCart.add(lineas) para los botones que
 * agregan VARIAS lineas de golpe y no salen de un formulario (el Duo Field
 * Package manda dos carriers, uno por color). Todo pasa por el mismo sitio,
 * asi que el aviso para el pixel y la apertura del drawer son identicos
 * vengan de donde vengan.
 */
(function () {
  'use strict';

  function abrirCarritoLateral() {
    // El Drawer del tema solo dispara su refresco de contenido (ajaxCart.load)
    // cuando el open() recibe un "evento" real; sin evento lo trata como
    // llamada externa y se abre vacio hasta el proximo refresco. Se le pasa
    // un evento de mentira con los metodos que el Drawer llama.
    var eventoFalso = { preventDefault: function () {}, stopPropagation: function () {} };
    if (window.theme && window.theme.RightDrawer && typeof window.theme.RightDrawer.open === 'function') {
      window.theme.RightDrawer.open(eventoFalso);
      return true;
    }
    return false;
  }

  function refrescarCarrito() {
    if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
      window.ajaxCart.load();
    }
  }

  /* Unico camino de "agregar al carrito" del sitio. Acepta el FormData de un
     formulario o una lista de lineas [{id, quantity}, ...]. Devuelve una
     promesa que revienta con el mensaje que manda Shopify (agotado, cantidad
     no disponible, etc.) para que quien llame decida donde pintarlo. */
  function enviarAlCarrito(carga) {
    var opciones = { method: 'POST', headers: { Accept: 'application/json' } };
    if (typeof FormData !== 'undefined' && carga instanceof FormData) {
      opciones.body = carga;
    } else {
      opciones.headers['Content-Type'] = 'application/json';
      opciones.body = JSON.stringify(Array.isArray(carga) ? { items: carga } : carga);
    }

    return fetch('/cart/add.js', opciones)
      .then(function (respuesta) {
        return respuesta.json().then(function (datos) {
          if (!respuesta.ok) {
            var error = new Error(datos.description || datos.message || 'No se pudo agregar al carrito.');
            error.datos = datos;
            throw error;
          }
          return datos;
        });
      })
      .then(function (datos) {
        // Aviso propio para cuando se conecte el pixel: no depende de que
        // el drawer del tema exista, asi que sirve igual si el tema cambia.
        document.dispatchEvent(new CustomEvent('bs:cart-item-added', { detail: datos }));
        if (!abrirCarritoLateral()) refrescarCarrito();
        return datos;
      });
  }

  window.BabySavageCart = {
    add: function (lineas) {
      return enviarAlCarrito(lineas);
    }
  };

  function mostrarErrorJuntoAlForm(form, mensaje) {
    var previo = form.querySelector('.bs-cart-error');
    if (previo) previo.remove();
    var aviso = document.createElement('div');
    aviso.className = 'bs-cart-error';
    aviso.setAttribute('role', 'alert');
    aviso.textContent = mensaje;
    aviso.style.cssText = 'margin-top:8px;padding:8px 10px;background:#fdecea;color:#611a15;font-size:13px;line-height:1.3;border-radius:4px;';
    form.appendChild(aviso);
  }

  document.addEventListener(
    'submit',
    function (evento) {
      var form = evento.target;
      if (!form || form.tagName !== 'FORM') return;
      var accion = form.getAttribute('action') || '';
      if (accion.indexOf('/cart/add') === -1) return;

      evento.preventDefault();

      var previo = form.querySelector('.bs-cart-error');
      if (previo) previo.remove();

      var boton = form.querySelector('[type="submit"]');
      if (boton) boton.disabled = true;

      enviarAlCarrito(new FormData(form))
        .catch(function (error) {
          mostrarErrorJuntoAlForm(form, (error && error.message) || 'No se pudo agregar al carrito. Intenta de nuevo.');
        })
        .then(function () {
          if (boton) boton.disabled = false;
        });
    },
    true
  );
})();
